import { every } from 'lodash';

export const areKeysEqual = (a, b, keys) => every(keys, (key) => a[key] === b[key]);

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
